import { PERIODO_ULTIMOS_7 } from '../../commons/filters/periodos.js';

export const SOLICITUDES_FILTROS_STORAGE_KEY = 'SolicitudesGrid_filtros';

export const getSolicitudesFilterDefaults = (intl) => ({
	periodo: {
		id: PERIODO_ULTIMOS_7,
		label: intl.formatMessage({ id: 'Ultimos_7_dias', defaultMessage: 'Últimos 7 días' }),
	},
});

const ANCHO_MEDIO = { xs: 12, sm: 6, md: 3, lg: 3 };

export const buildSolicitudesFilterFields = (intl) => [
	{
		name: 'entidad',
		type: 'text',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.entidad', defaultMessage: 'Entidad' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'estado',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.estado', defaultMessage: 'Estado' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'base',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.base', defaultMessage: 'Base' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'region',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.region', defaultMessage: 'Región' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'periodo',
		type: 'periodo',
		startName: 'fechaDesde',
		endName: 'fechaHasta',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.fecha_alta', defaultMessage: 'Fecha de alta' }),
		size: ANCHO_MEDIO,
	},
];
